/**
 * Created by Mohammadreza on 05/09/2020.
 */
import { Injectable }     from '@angular/core';
import { Response } from '@angular/http';
import {Observable} from 'rxjs/Rx';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import {BaseHttpService} from "../base-http-service";
import {
  API_URL_GET_COMPANY_CUSTOMER_BY_USER_ID_AND_COMPANY_ID,
  API_URL_GET_USER_INFO_BY_ID,
  API_URL_SEND_ACTIVATION_CODE_BY_COMPANY, API_URL_VERIFY_NATIONAL_CODE_BY_SABT_AHVAL
} from "../constants";



@Injectable()
export class PersonService {
  constructor(private http:BaseHttpService) {


  }
  getUserInfo(userId):Observable<any> {
    if (userId) {
      return this.http.get(API_URL_GET_USER_INFO_BY_ID + '/' + userId).map((res:Response) => {
        return res;
      })
        //...errors if any
        .catch((error:any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }
  getCompanyCustomerByUserIdAndCompanyId(userId,companyId):Observable<any> {
    if (userId) {
      return this.http.get(API_URL_GET_COMPANY_CUSTOMER_BY_USER_ID_AND_COMPANY_ID + '/' + userId + '/' + companyId).map((res:Response) => {
        return res;
      })
        //...errors if any
        .catch((error:any) => Observable.throw(error || 'Server error'));
      //   }
    }
  }
  verifyNationalCodeBySabtAhval(nationalCode:String,birthDate:String,onSuccess,onError):void {
    this.http.get(API_URL_VERIFY_NATIONAL_CODE_BY_SABT_AHVAL + '/' + nationalCode+ '/' + birthDate)
      .subscribe((res:Response) => {onSuccess(res)},(error:any) => {onError(error);})
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/person/person-service.ts